import React from "react";
import { Modal, Button } from "react-bootstrap";
import { t } from "../../i18n";

export interface LargeFractionEntry {
  // Where the fraction came from, e.g. "Default fraction" or "Level 5", already localised by the caller.
  label: string;
  fraction: number;
}

interface Props {
  show: boolean;
  entries: LargeFractionEntry[];
  threshold: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export const LargeFractionConfirmationDialog: React.FC<Props> = ({ show, entries, threshold, onConfirm, onCancel }) => {
  // Fractions are small decimals; show enough precision to read a threshold like 0.001 without rounding it away.
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 8,
  });

  return (
    <Modal
      show={show}
      onHide={onCancel}
    >
      <Modal.Header closeButton>
        <Modal.Title>{t("dialog.largeFraction.title", undefined, "Unusually large fraction")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="alert alert-warning">
          <p>
            <strong>
              {t(
                "dialog.largeFraction.message",
                { threshold: formatter.format(threshold) },
                "You are about to save a cashback configuration with a fraction of {{threshold}} or more, which may pay out far more than intended:",
              )}
            </strong>
          </p>
          <ul>
            {entries.map((entry, index) => (
              <li key={index}>
                <strong>{entry.label}:</strong> {formatter.format(entry.fraction)}
              </li>
            ))}
          </ul>
          <p className="mb-0">{t("dialog.largeFraction.confirm", undefined, "Please confirm that you want to save this configuration.")}</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onCancel}
          data-testid="large-fraction-dialog-cancel"
        >
          {t("button.cancel", undefined, "Cancel")}
        </Button>
        <Button
          variant="primary"
          onClick={onConfirm}
          data-testid="large-fraction-dialog-confirm"
        >
          {t("button.confirm", undefined, "Confirm")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
